/**
 * 前端企业配置管理
 * 根据URL域名确定当前企业的前端配置（API地址、企业标识等）
 * 企业微信相关的敏感配置（corp_id, secret等）从后端动态获取
 */

const development = process.env.NODE_ENV === 'development'

// 前端企业配置映射（只包含前端需要的静态配置）
const ENTERPRISE_CONFIGS = {
  // 能者科技 - 测试环境
  'invoices-test.oa.nzqifu.com': {
    id: 'nzqifu',
    name: '能者科技',
    identifier: 'nzqifu',  // 英文标识符，用于API传递（与后端 code 字段一致）
    displayName: '能者科技（测试环境）',
    environment: 'development',
    apiBaseUrl: 'http://invoices-test.oa.nzqifu.com:18080/api',
    frontendBaseUrl: 'http://invoices-test.oa.nzqifu.com',
    // 企业微信配置
    corpId: 'ww701da2fa3f729b79',
    expenseAgentId: 1000018,
    paymentAgentId: 1000018,
    financeDepartmentId: 3,
    theme: {
      primaryColor: '#1890ff',
      logo: '/assets/logo-nzqifu.png'
    }
  },
  
  // 喜陶陶 - 生产环境  
  'invoices.oa.nzqifu.com': {
    id: 'xitaotao',
    name: '喜陶陶',
    identifier: 'xitaotao',  // 英文标识符，用于API传递（与后端 code 字段一致）
    displayName: '喜陶陶',
    environment: 'production',
    apiBaseUrl: 'https://invoices.oa.nzqifu.com/api',
    frontendBaseUrl: 'https://invoices.oa.nzqifu.com',
    // 企业微信配置
    corpId: 'wwca551919313eb542',
    expenseAgentId: 1000040,
    paymentAgentId: 1000040,
    financeDepartmentId: 3,
    theme: {
      primaryColor: '#52c41a',
      logo: '/assets/logo-xitaotao.png'
    }
  },
  
  // 东电云 - 生产环境
  'invoices.oa.ddypt.com': {
    id: 'dongdian',
    name: '东电云',
    identifier: 'dongdian',  // 英文标识符，用于API传递（与后端 code 字段一致）
    displayName: '东电云',
    environment: 'production',
    apiBaseUrl: 'https://invoices.oa.ddypt.com/api',
    frontendBaseUrl: 'https://invoices.oa.ddypt.com',
    // 企业微信配置
    corpId: 'wwca25754681adc0a5',
    expenseAgentId: 1000005,
    paymentAgentId: 1000005,
    financeDepartmentId: 7,
    theme: {
      primaryColor: '#722ed1',
      logo: '/assets/logo-dongdianyun.png'
    }
  },
  // 能者云创 - 生产环境
  'invoices.oa.nzzbw.com': {
    id: 'nzyc',
    name: '能者云创',
    identifier: 'nzyc',  // 英文标识符，用于API传递（与后端 code 字段一致）
    displayName: '能者云创',
    environment: 'production',
    apiBaseUrl: 'https://invoices.oa.nzzbw.com/api',
    frontendBaseUrl: 'https://invoices.oa.nzzbw.com',
    // 企业微信配置
    corpId: 'ww6799a3e5a4fabcbb',
    expenseAgentId: 1000002,
    paymentAgentId: 1000002,
    financeDepartmentId: 7,
    theme: {
      primaryColor: '#722ed1',
      logo: '/assets/logo-nengzheyunchuang.png'
    }
  },

  // 本地开发默认配置
  'localhost': {
    id: development ? 'nzqifu' : 'dongdian',
    name: development ? '能者科技' : '东电云',
    identifier: development ? 'nzqifu' : 'dongdian',  // 英文标识符，用于API传递（与后端 code 字段一致）
    displayName: development ? '本地开发环境' : '本地生产测试',
    environment: development ? 'development' : 'production',
    apiBaseUrl: development 
      ? 'http://[::1]:18080/api'  // 本地开发时直接连本地后端
      : 'http://invoices.oa.ddypt.com:18080/api',
    frontendBaseUrl: development 
      ? 'http://localhost:8080' 
      : 'http://invoices.oa.ddypt.com',
    // 企业微信配置
    corpId: development ? 'ww701da2fa3f729b79' : 'wwca25754681adc0a5',
    expenseAgentId: development ? 1000018 : 1000005,
    paymentAgentId: development ? 1000018 : 1000024,
    financeDepartmentId: 3,
    theme: {
      primaryColor: '#1890ff',
      logo: '/assets/logo-dev.png'
    }
  },

  // 支持IP访问的开发配置
  '127.0.0.1': {
    id: 'nzqifu',
    name: '能者科技',
    identifier: 'nzqifu',  // 英文标识符，用于API传递（与后端 code 字段一致）
    displayName: '本地开发环境（IP访问）',
    environment: 'development',
    apiBaseUrl: 'http://127.0.0.1:5000/api',
    frontendBaseUrl: 'http://127.0.0.1:8080',
    // 企业微信配置
    corpId: 'ww701da2fa3f729b79',
    expenseAgentId: 1000018,
    paymentAgentId: 1000018,
    financeDepartmentId: 3,
    theme: {
      primaryColor: '#1890ff',
      logo: '/assets/logo-dev.png'
    }
  }
}

/**
 * 根据当前URL确定企业配置
 */
function getCurrentEnterpriseConfig() {
  const hostname = window.location.hostname
  
  // 直接匹配域名
  if (ENTERPRISE_CONFIGS[hostname]) {
    return ENTERPRISE_CONFIGS[hostname]
  }
  
  // 检查是否包含特定关键词
  for (const domain in ENTERPRISE_CONFIGS) {
    if (hostname.includes(domain) || domain.includes(hostname)) {
      return ENTERPRISE_CONFIGS[domain]
    }
  }
  
  // 从环境变量获取企业标识
  const enterpriseFromEnv = process.env.VUE_APP_ENTERPRISE_NAME
  if (enterpriseFromEnv) {
    const config = Object.values(ENTERPRISE_CONFIGS).find(
      config => config.enterpriseName === enterpriseFromEnv
    )
    if (config) return config
  }
  
  // 默认配置（本地开发）
  return ENTERPRISE_CONFIGS['localhost']
}

/**
 * 获取前端配置（包含API地址、主题等静态配置）
 */
export function getFrontendConfig() {
  const config = getCurrentEnterpriseConfig()
  
  console.log(`🏢 当前企业: ${config.displayName}`)
  console.log(`🌐 API地址: ${config.apiBaseUrl}`)
  console.log(`🎨 主题色彩: ${config.theme.primaryColor}`)
  
  return {
    // 企业标识信息
    enterpriseId: config.id,
    enterpriseName: config.name,
    enterpriseIdentifier: config.identifier,  // 英文标识符，用于API传递
    displayName: config.displayName,
    environment: config.environment,
    
    // API配置
    apiBaseUrl: config.apiBaseUrl,
    frontendBaseUrl: config.frontendBaseUrl,
    wxApiUrl: 'https://qyapi.weixin.qq.com/cgi-bin/user/getuserinfo/',
    
    // 企业微信配置
    corpId: config.corpId,
    expenseAgentId: config.expenseAgentId,
    paymentAgentId: config.paymentAgentId,
    financeDepartmentId: config.financeDepartmentId,
    
    // UI配置
    theme: config.theme,
    
    // 兼容旧版本
    baseUrl: config.apiBaseUrl,
    loaclUrl: config.frontendBaseUrl,
    wxUrl: 'https://qyapi.weixin.qq.com/cgi-bin/user/getuserinfo/',
  }
}

/**
 * 获取企业名称（用于后端API调用）
 */
export function getCurrentEnterpriseName() {
  const config = getCurrentEnterpriseConfig()
  return config.name
}

/**
 * 获取企业ID
 */
export function getCurrentEnterpriseId() {
  const config = getCurrentEnterpriseConfig()
  return config.id
}

/**
 * 获取当前环境
 */
export function getCurrentEnvironment() {
  const config = getCurrentEnterpriseConfig()
  return config.environment
}

/**
 * 检查是否为开发环境
 */
export function isDevelopmentEnvironment() {
  const config = getCurrentEnterpriseConfig()
  return config.environment === 'development'
}

/**
 * 获取主题配置
 */
export function getThemeConfig() {
  const config = getCurrentEnterpriseConfig()
  return config.theme
}

/**
 * 获取API配置（兼容旧版本）
 * @deprecated 请使用 getFrontendConfig()
 */
export function getApiConfig() {
  return getFrontendConfig()
}

export default {
  getFrontendConfig,
  getCurrentEnterpriseName,
  getCurrentEnterpriseId,
  getCurrentEnvironment, 
  isDevelopmentEnvironment,
  getThemeConfig,
  getApiConfig // 兼容旧版本
}
